import { useEffect, useState } from "react";
import { Text, Button } from "@ui-component-library";
import { fetchPosts } from "../../api/services/posts";

const PostV2 = (props) => {
  const [post, setPost] = useState([]);

  useEffect(() => {
    fetchData();
  }, [props.category]);

  const fetchData = async () => {
    const resp = await fetchPosts({pagesize: 1, pageNr: 1, category: props.category?.value});

    if(resp.ok && resp.data.posts.length > 0) {
      setPost(resp.data.posts[0]);
    } else {
      setPost({id: 0, title: 'No post found', description: 'No post found', image_url: 'https://placehold.co/800x600', url: '/'});
    }
  };

  return (
    <div className="w-full bg-[#252524]">
      <section className="w-full py-24 container">
        <Text variant="text-5xl/leading-normal/medium" className="text-[#FBFBFB] mb-[20px]">{props.title}</Text>

        <Text variant="text-base/leading-normal/normal" className="text-[#F5F5F5] mb-12">{props.description}</Text>

        <div className="flex flex-col justify-end rounded-[24px] p-8 aspect-video overflow-hidden bg-cover bg-center" style={{ backgroundImage: `var(--background-image-linear-overlay-50, transparent), url(${post.image_url})` }}>
          <Text variant="text-4xl/leading-normal/medium" className="text-[#F5F5F5] max-w-[512px] mb-12">{post.title}</Text>

          <Button variant="primary" size="medium" className="w-fit" onClick={() => window.location.href=post.url}>Läs mer</Button>
        </div>
      </section>
    </div>
  );
};

PostV2.defaultProps = {
  category: {label: 'Allt', value: 'Allt'},
  title: "Headline that solves user's main problem",
  description: "Description of the post",
};

PostV2.fields = {
  category: {type: "external",
    fetchList: async () => {
      const resp = await fetch("/admin-api/category/");
      const resp_json = await resp.json();
      return resp_json.map((cat) => {return {"label": cat.name, "value": cat.id}});
    },
  },
  title: {
    type: "text",
    label: "Title",
  },
  description: {
    type: "text",
    label: "Description",
  },
};

export default PostV2;
